import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            为什么 300 万吃瓜群众选择黑料爆料？因为我们把"真实"和"速度"刻进了 DNA。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-50">
                <i className={`${feature.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}